export const PERMISSION_FEATURES = {
  ADD: "Add",
  VIEW: "View",
  EDIT: "Edit",
  DELETE: "Delete",
  EDIT_ACCOUNTING: "Edit-Accounting",
  EDIT_PRICING: "Edit-Pricing",
  EDIT_IMPORT: "Edit-Import",
  VALIDATE_ENTRY: "Validate-Entry",
  SEND_EMAIL: "Send-Email",
  RE_ATTACH: "Re-Attach",
};

export const MODULES = {
  USER_MANAGEMENT: "UserManagement",
  CUSTOMER_MANAGEMENT: "CustomerManagement",
  EDO: "EDO",
  MDO: "MDO",
  ACCESS_MANAGEMENT: "AccessManagement",
  APPROVALS: "Approval",
  NOTICE_MANAGEMENT: "Notice",
  VESSEL_NOTICE: "VesselNotice",
  SALES_NOMINATION: "SalesNomination",
  TERMINAL_MANAGEMENT: "TerminalManagement",
  // DASHBOARD: "dashboard",
  // SETTINGS: "settings",
};
